import React from 'react';
import { Text, VStack, Image } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';

interface SignInSignUpModalProps {
  isOpen: boolean;
  onClose: () => void;
  returnTo: string;
  returnState: any;
}

const SignInSignUpModal: React.FC<SignInSignUpModalProps> = ({ isOpen, onClose, returnTo, returnState }) => {
  const navigate = useNavigate();

  const handleNewUser = () => {
    navigate('/signup-application', { state: { returnTo: returnTo, state: returnState } });
    onClose();
  };

  const handleReturningUser = () => {
    navigate('/returning-user', { state: { returnTo: returnTo, state: returnState } });
    onClose();
  };

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title="Sign In to Continue"
      cancelLabel="Sign Up"
      onCancel={handleNewUser}
      primary={{ label: 'Sign In', onClick: handleReturningUser, arrow: true }}
    >
      <VStack spacing={5} align="stretch">
        <Image
          src="https://firebasestorage.googleapis.com/v0/b/storyitapp.appspot.com/o/touchpoints%2FFoodFluence.io%20Logo%20(461%20x%20196%20px)%20(6).png?alt=media&token=54ec9ac5-6bd9-40e1-98c4-12597c3953a1"
          alt="FoodFluencer Logo"
          objectFit="contain"
          maxH="64px"
          mx="auto"
        />
        <Text color={ff.text2}>
          Please sign in or create an account to continue with this collaboration
        </Text>
      </VStack>
    </ModalShell>
  );
};

export default SignInSignUpModal;
